// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_content__qva9E {
    width: 100%;
}

.styles_content__qva9E>div {
    width: 100%;
}

/* .content>div:nth-child(1)>div:nth-child(1) {
    margin-top: 5px;
} */
.styles_extraSpace__b8n0H {
    padding-top: 5px;
}

.styles_myMessage__29Df9 {
    margin-right: 30px;
}

.styles_removeFav__ocbh\\+ {
    position: absolute;
    top: 4px;
    width: auto !important;
}

.styles_left__7cD1C {
    left: 10px;
}

.styles_confirmModal__\\+6Woz {
    position: absolute;
    width: auto;
    height: auto;
    margin: auto;
    padding: 20px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/SingleMessage/styles.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;;GAEG;AACH;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".content {\n    width: 100%;\n}\n\n.content>div {\n    width: 100%;\n}\n\n/* .content>div:nth-child(1)>div:nth-child(1) {\n    margin-top: 5px;\n} */\n.extraSpace {\n    padding-top: 5px;\n}\n\n.myMessage {\n    margin-right: 30px;\n}\n\n.removeFav {\n    position: absolute;\n    top: 4px;\n    width: auto !important;\n}\n\n.left {\n    left: 10px;\n}\n\n.confirmModal {\n    position: absolute;\n    width: auto;\n    height: auto;\n    margin: auto;\n    padding: 20px;\n    height: 200px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `styles_content__qva9E`,
	"extraSpace": `styles_extraSpace__b8n0H`,
	"myMessage": `styles_myMessage__29Df9`,
	"removeFav": `styles_removeFav__ocbh+`,
	"left": `styles_left__7cD1C`,
	"confirmModal": `styles_confirmModal__+6Woz`
};
export default ___CSS_LOADER_EXPORT___;
